import { NavLink, useLocation } from 'react-router-dom';
import { FiHome, FiSearch, FiBookmark, FiUser } from 'react-icons/fi';
import { useAuth } from './AuthContext';

/**
 * Android-style bottom tab bar. Rendered on every route but only painted on
 * small screens (see .mobile-tabs in mobile.css), so the desktop navigation
 * stays exactly as it was.
 */
const tabs = [
  { to: '/', label: 'Home', icon: FiHome, end: true },
  { to: '/search', label: 'Search', icon: FiSearch },
  { to: '/me#collections', label: 'Saved', icon: FiBookmark, match: '/me' },
  { to: '/orbit', label: 'You', icon: FiUser },
];

const openSearch = () => window.dispatchEvent(new CustomEvent('hedone:open-search'));

export default function BottomTabs({ onSearch = openSearch }) {
  const location = useLocation();
  const { user, openAuth } = useAuth();

  return (
    <nav className="mobile-tabs" aria-label="Primary">
      {tabs.map(({ to, label, icon: Icon, end, match }) => {
        const active = end ? location.pathname === to : location.pathname.startsWith(match || to);
        if (to === '/search') {
          return (
            <button key={to} type="button" className="mobile-tab" onClick={onSearch} aria-label="Search movies and series">
              <Icon aria-hidden="true" /><span>{label}</span>
            </button>
          );
        }
        if (to === '/me#collections' && !user) {
          return (
            <button key={to} type="button" className="mobile-tab" onClick={openAuth} aria-label="Sign in to see saved titles">
              <Icon aria-hidden="true" /><span>{label}</span>
            </button>
          );
        }
        return (
          <NavLink key={to} to={to} end={end} className={`mobile-tab ${active ? 'is-active' : ''}`}>
            <Icon aria-hidden="true" /><span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
